import { Skeleton, notification } from "antd";
import mixpanel from "mixpanel-browser";
import moment from "moment";
import {
  browserName,
  fullBrowserVersion,
  osName,
  osVersion,
  isMobile,
  mobileVendor,
  mobileModel,
} from "react-device-detect";

import journalPhoto from "../images/journal.svg";
import jobPhoto from "../images/job-icon.svg";
import covidPhoto from "../images/covid-icon.svg";

export const getBasicAuthHeadersElastic = () => {
  const headers = {
    Authorization:
      "Basic " +
      btoa(
        process.env.REACT_APP_ELASTIC_USER +
          ":" +
          process.env.REACT_APP_ELASTIC_PASS
      ),
  };
  return headers;
};

/**
 * @function getAuthHeaders
 * @desc This handles returns the auth headers array, which can be used in making api requests
 */
export const getAuthHeaders = () => {
  let authToken = localStorage.getItem("authToken");
  if (authToken) {
    let headers = {
      "Content-Type": "application/json",
      Authorization: authToken,
    };
    return headers;
  } else {
    return null;
  }
};

export const ShowSkeltons = (num) => {
  return (
    <>
      {[...Array(num)].map(() => (
        <Skeleton
          className="news-skelton"
          loading={true}
          avatar
          active
        ></Skeleton>
      ))}
    </>
  );
};

/**
 * @function formatedShortDate
 * @param date
 * @desc this function will return the formated short date like- 08 Aug 2020
 */
export const formatedShortDate = (date) => moment(date).format("Do MMM YYYY");

export const capitalize = (s) => {
  return s.toLowerCase().replace(/\b./g, function (a) {
    return a.toUpperCase();
  });
};

export const fetchOtherNewsCardImage = (newsType) => {
  let sourceUrlObj = {
    sourceUrl: null,
    sourceUrlClass: null,
  };
  switch (newsType) {
    case "JOB":
      sourceUrlObj.sourceUrl = jobPhoto;
      sourceUrlObj.sourceUrlClass = "job_photo";
      break;
    case "JOURNAL":
      sourceUrlObj.sourceUrl = journalPhoto;
      sourceUrlObj.sourceUrlClass = "journal_photo journal-icon-bg";
      break;
    case "COVID19":
      sourceUrlObj.sourceUrl = covidPhoto;
      sourceUrlObj.sourceUrlClass = "covid_photo covid-icon-bg";
      break;
    default:
      break;
  }
  return sourceUrlObj;
};

export const capitalizeString = (textToCapitalize) => {
  if (textToCapitalize) {
    const textToCapitalizeStr = textToCapitalize.toLowerCase();
    return (
      textToCapitalizeStr.charAt(0).toUpperCase() + textToCapitalizeStr.slice(1)
    );
  }
};

export const ShowNotification = ({ type, message, description, duration }) => {
  return notification[type]({
    message: message ? message : type,
    duration: duration ? duration : 4,
    description,
  });
};

export const isResponsiveWidth = () => {
  let isResponsive = false;
  const w =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  if (w >= 768) {
    isResponsive = true;
  }
  return isResponsive;
};

/**
 * @function getUserId
 * @desc returns User id
 */
export const getUserId = () => {
  let userId = null;
  const user = localStorage.getItem("user");
  if (user) {
    userId = JSON.parse(user).id;
  }
  return userId;
};

export const getBrowserDetails = () => {
  return {
    browser_name: browserName,
    browser_version: fullBrowserVersion,
    os_name: osName,
    os_version: osVersion,
    screen_width: window.innerWidth,
    screen_height: window.innerHeight,
    device_name:
      isMobile && !isResponsiveWidth()
        ? `${mobileVendor} ${mobileModel}`
        : null,
    url: window.location.href,
    user_id: getUserId() || null,
    // clinic_id: localStorage.getItem("clinic_id") || null,
    role: null,
    platform:
      isMobile && !isResponsiveWidth() ? "mobile_browser" : "web_browser",
    app: "NEWS",
  };
};

/**
 * @function logMixpanelEvent
 * @params event
 * @description  sends mixpanel data to api
 */
export const logMixpanelEventBasic = (
  eventName,
  type = null,
  fromParam = null,
  taskParam = null,
  app = "NEWS",
  role = null
) => {
  const mixpanelData = getBrowserDetails();
  if (type) {
    mixpanelData.type = type;
  }
  if (fromParam) {
    mixpanelData.from = fromParam;
  }
  if (taskParam) {
    mixpanelData.task = taskParam;
  }
  if (app) {
    mixpanelData.app = app;
  }
  if (role) {
    mixpanelData.role = role;
  }
  mixpanel.track(eventName, mixpanelData);
};

/**
 * @function getAppEnv
 * @desc This returns the current application environment:
 * @retuns dev, stg or prod
 */
export const getAppEnv = () => {
  let appEnv = "";
  if (window && window.location) {
    const winProtocol = window.location.protocol;
    const winHostname = window.location.hostname;
    if (winHostname === process.env.REACT_APP_DEV_HOST_NAME) {
      appEnv = winProtocol === "http:" ? "dev" : "stg";
    }
    if (winHostname === process.env.REACT_APP_PROD_HOST_NAME) {
      appEnv = "prod";
    }
  } else {
    appEnv = process.env.REACT_APP_ENV;
  }
  return appEnv;
};

/**
 * @function getUser
 * @desc This returns user info if the user is logged in
 */
export const getUser = function () {
  let user = localStorage.getItem("user");
  let authToken = localStorage.getItem("authToken");
  return user && authToken ? JSON.parse(user) : null;
};

/**
 * @function getCookie
 * @param "cname"
 * @desc This function get a cookie value
 */
export const getCookie = (cname) => {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
};

/**
 * @function setCookie
 * @param "cname", "cvalue"
 * @desc This function sets the cookie
 */
export const setCookie = (cname, cvalue) => {
  let expires = "";
  const exdays = 30; // exdays -> number of days after which cookie will expire

  const date = new Date();
  date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
  expires = `; expires=${date.toGMTString()}`;

  document.cookie = `${cname}=${cvalue}${expires};domain=.kulcare.com;path=/;`;
};

export const deleteCookie = (name) => {
  document.cookie = `${name}=; path=/; domain=.kulcare.com;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};

/**
 * @function getDoctorAccount
 * @desc returns patient id
 */
export const getDoctorAccount = () => {
  let docAccount = [];
  let user = localStorage.getItem("user");
  if (user) {
    user = JSON.parse(user);
    docAccount = user?.user_accounts?.filter(
      (account) => account.account_type === "doctor"
    );
  }
  if (docAccount.length > 0) return docAccount[0];
  else return null;
};

/**
 * @function logoutAction
 * @param dispatch
 * @desc This function logout the user.
 */
export const logout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("authToken");
  localStorage.removeItem("doctor_id");
  localStorage.removeItem("doctor_name");
  localStorage.removeItem("user_verified");
  localStorage.removeItem("filterBy");

  mixpanel.reset();
  deleteAllCookies();
  window.location.replace("/");
};

/**
 * @function deleteAllCookies
 * @desc This function deletes all cookies
 */
export const deleteAllCookies = () => {
  const appEnv = getAppEnv();
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    if (
      name &&
      name.trim() !== `${appEnv}_current_language` &&
      name.trim() !== `${appEnv}_return_url`
    ) {
      document.cookie = `${name}=; path=/; domain=.kulcare.com;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    }
  }
};

/** *
 * @function keyLocallyPresentInStorage
 * @param key
 * @desc This method checks if value presents
 * in local storage or session storage
 */
export const keyLocallyPresentInStorage = (key) => {
  const keyPresent =
    localStorage.getItem(key) &&
    localStorage.getItem(key) != "undefined" &&
    localStorage.getItem(key) !== null &&
    localStorage.getItem(key) !== "null";
  return keyPresent;
};
